import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { SWRConfig } from 'swr';

import { router } from './app/routes';
import { ErrorBoundary } from './app/ErrorBoundary';
import { AuthProvider } from './contexts/AuthContext';
import { swrConfig } from './lib/swr';
import { useAppStore } from './stores/app';

export function App() {
  const { theme, setTheme } = useAppStore();

  // Initialize theme on app start
  useEffect(() => {
    setTheme(theme);
  }, [theme, setTheme]);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <SWRConfig value={swrConfig}>
          <RouterProvider router={router} />
        </SWRConfig>
      </AuthProvider>
    </ErrorBoundary>
  );
}